import * as React from 'react';

import { usePageContext } from '../../context';

const PageFeaturedImage: React.FC = ({ ...props }) => {
  const { meta } = usePageContext();

  return (
    <div {...props}>
      {
        // eslint-disable-next-line @next/next/no-img-element
        meta?.featuredImage && <img src={meta.featuredImage} alt="" />
      }
    </div>
  );
};

export default PageFeaturedImage;
